module.exports = __webpack_public_path__ + "img/van-shuttle.b5dbbc84.svg";